/**
 * Where a person who cannot get into the portal writes to Petrovic.
 *
 * The three sign-in screens used to say "den vanliga kontaktvägen", which is nothing to go on at
 * exactly the moment a person has nothing else: they cannot sign in, so they cannot reach the chat.
 * Decided by Mattej 2026-09-24, docs/polish.md P-14. The address lives here and nowhere else, so
 * changing it is one line; `tests/polish-language.test.ts` holds the screens to reading it from here.
 */
export const CONTACT_EMAIL = "kontakt@petrovicsystems.com";

export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;
